<script setup>
const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: [String, Number],
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const selectTab = (value) => {
  emit("update:modelValue", value);
};
</script>

<template>
  <div class="tabs">
    <div
      v-for="tab in tabs"
      :key="tab.value"
      class="tab"
      :class="{ active: tab.value === props.modelValue }"
      @click="selectTab(tab.value)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<style lang="scss" scoped>

.tabs {
  display: flex;
  gap: 24px;
}

.tab {
  padding-bottom: 8px;
  cursor: pointer;
  color: $grey;
  font-size: 14px;
  font-weight: 400;
  position: relative;
  transition: color 0.3s;
  user-select: none;

  &.active {
    color: $blue;
    font-weight: 500;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: $blue;
      border-radius: 2px 2px 0 0;
    }
  }

  &:hover {
    color: $blue;
  }
}
</style>
